import React, {createContext, useState, useContext, ReactNode} from 'react';
import { getAccessToken } from './auth.util';
import { TWS_API_URL } from '../environment/apis.config';

interface SensorEventContextType {
  activeEventSensorId: Record<string, any>;
  setActiveEventsSensors: React.Dispatch<React.SetStateAction<Record<string, any>>>;
}

export const SensorEventContext = createContext<SensorEventContextType | undefined>(undefined);

export function SensorEventProvider({children } : {children : ReactNode}){
    const [activeEventSensorId, setActiveEventsSensors] = useState({});
    return (
        <SensorEventContext.Provider value={{activeEventSensorId, setActiveEventsSensors}}> 
            {children}
        </SensorEventContext.Provider>
    );
}

export function useSensorEventContext(){
  const context = useContext(SensorEventContext);
  if (!context) {
    throw new Error('useSensorEventContext must be used within a SensorEventProvider');
  }
  return context;
}

export const getActiveSensorEventsID = async() => {
    const token = await getAccessToken();
    const response = await fetch(
    `${TWS_API_URL}/activeEventSensorId`,
    {
        method: 'GET',
        headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        }
    }
    ) 
    const data = await response.json()    
    return data.activeEventsSensorId   
}

export const getActiveHazards = async(id : string) => {
    const hazardMapping: Record<string, string> = {
      SENSOR_CEILINGS: "ceiling",
      SENSOR_VISIBILITY: "visibility",
      SENSOR_WINDS: "wind",
      SENSOR_WINDGUSTS: "wind_gust",
      SENSOR_TEMPERATURE: "temperature"
    };
    const token = await getAccessToken();
    const response = await fetch(
      `${TWS_API_URL}/sensorAlerts?sensorId=${id}`,
      {
          method: 'GET',
          headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          }
      }
    ) 
    const data = await response.json()
    let hazardList = []
    for(let alert of data) hazardList.push(hazardMapping[alert?.hazardType])
    return hazardList   
}


